import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroImage from './components/HeroImage';
import WelcomeSection from './components/WelcomeSection';
import FeaturesSection from './components/FeaturesSection';
import FooterSection from './components/FooterSection';
import AboutUs from './components/AboutUs';
import AboutHero from './components/AboutHero';
import ActivitiesPage from './components/ActivitiesPage';
import ContactPage from './components/ContactPage';
import RoomsPage from './components/RoomsPage'
import HowToGetThere from './components/HowToGetThere';
import './styles/App.css';

const HomePage = ({ isScrolled }) => {
  return (
    <>
      <Header isScrolled={isScrolled} />
      <section className="hero-section">
        <HeroImage />
          <div className="welcome-section">
            <WelcomeSection isScrolled={isScrolled}/>
          </div>
      </section>
     
      <section className="features-section">
        <FeaturesSection />
      </section>
    </>
  );
};

const AboutPage = ({ isScrolled }) => {
  return (
    <>
      <Header isScrolled={isScrolled} />
      <section className="hero-section about-hero">
        <AboutHero />
      </section>
      <AboutUs />
    </>
  );
};

const ActivitiesPageWrapper = ({ isScrolled }) => {
  return (
    <>
      <Header isScrolled={isScrolled} />
      <section className="hero-section about-hero">
        <AboutHero />
      </section>
      <ActivitiesPage />
    </>
  );
};

const ContactPageWrapper = ({ isScrolled }) => {
  return (
    <>
      <Header isScrolled={isScrolled} />
      <section className="hero-section about-hero">
        <AboutHero />
      </section>
      <ContactPage />
    </>
  );
};

const RoomsPageWrapper = ({ isScrolled }) => {
  return (
    <>
      <Header isScrolled={isScrolled} />
      <section className="hero-section about-hero">
        <AboutHero />
      </section>
      <RoomsPage />
    </>
  );
};

const HowToGetThereWrapper = ({ isScrolled }) => {
  return (
    <>
      <Header isScrolled={isScrolled} />
      <section className="hero-section about-hero">
        <AboutHero />
      </section>
      <HowToGetThere />
    </>
  );
};

const App = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<HomePage isScrolled={isScrolled} />} />
          <Route path="/about" element={<AboutPage isScrolled={isScrolled} />} />
          <Route path="/activities" element={<ActivitiesPageWrapper isScrolled={isScrolled} />} />
          <Route path="/contact" element={<ContactPageWrapper isScrolled={isScrolled} />} />
          <Route path="/rooms" element={<RoomsPageWrapper isScrolled={isScrolled} />} />
          <Route path="/how-to-get-there" element={<HowToGetThereWrapper isScrolled={isScrolled} />} />
        </Routes>
        <footer className="footer">
          <FooterSection />
        </footer>
      </div>
    </Router>
  );
};

export default App;
